import item1 from '../assets/stories/stories-image-1.png';
import item2 from '../assets/stories/stories-image-2.png';
import item3 from '../assets/stories/stories-image-3.png';
import item4 from '../assets/stories/stories-image-4.png';
import item5 from '../assets/stories/stories-image-5.png';
import item6 from '../assets/stories/stories-image-6.png';

export const STORIES = [
    {
        id: '1',
        sponsorsAmount: 0,
        donationsAmount: 0,
        image: item1,
        title: 'Bread for the Journey Supports Change of Omaha!',
        description:
            'Bread For The Journey is super excited and has provided a grant to Change of Omaha! Change of Omaha is a new organization and is moving full steam ahead with initiatives to bring positive change and equity to the Omaha community. Change of Omaha has three major goals. Community Revitalization, Fighting Systemic Racism, and the Eradication of Food Insecurity',
        link: '#',
    },
    {
        id: '2',
        sponsorsAmount: 0,
        donationsAmount: 0,
        image: item2,
        title: 'Susan Rogert’s Healing Day Program',
        description:
            'Susan Rogert has received a BFJ grant for her healing day program to assist all Omaha first responders and veterans in stress reduction and relaxation. Susan is a Usui Reiki Master in the Omaha area. She loves helping people...',
        link: '#',
    },
    {
        id: '3',
        sponsorsAmount: 0,
        donationsAmount: 0,
        image: item3,
        title: 'Congratulations to oneleif!',
        description:
            'Congratulations to the oneleif management team on receiving the latest Bread For the Journey grant! We are excited to support this effort that gives people a chance to expand their IT skills while helping small businesses and non-profits with...',
        link: '#',
    },
    {
        id: '4',
        sponsorsAmount: 0,
        donationsAmount: 0,
        image: item4,
        title: 'Making Special Spaces for Ill Children',
        description:
            'Please join us in congratulating Ronnie Thomas on a BFJ grant. Ronnie is going to start an Omaha Chapter of Special Spaces. Special Spaces creates dream bedrooms for children with life-threatening medical illnesses. This is a place that only...',
        link: '#',
    },
    {
        id: '5',
        sponsorsAmount: 0,
        donationsAmount: 0,
        image: item5,
        title: 'Tiny House Turned Mobile Clinic',
        description:
            'Please join us in congratulating Cherisa Meyer-Fletcher who is in the process of establishing a 501c3 called Cornerstone Nonprofit. She just received a grant from BFJ. Cherisa is a Physician’s Assistant, and has this fabulous idea to create a...',
        link: '#',
    },
    {
        id: '6',
        sponsorsAmount: 0,
        donationsAmount: 0,
        image: item6,
        title: 'Thriving Titans Caring for Homeless Students',
        description:
            'Congratulations to Annie Esterling and her Thriving Titans non- profit. She is the latest recipient of a BFJ grant. Thriving Titans are families and businesses that want to ensure all students at Lewis Central Community Schools have everything they...',
        link: '#',
    },
];
